import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import SanitizeHelper from "~helpers/SanitizeHelper";

const getProxy = (search) => {
  const params = new URLSearchParams(search);

  return new Proxy(params, {
    get(target, prop, receiver) {
      if (typeof prop === "symbol") {
        const value = Reflect.get(target, prop, receiver);
        return typeof value === "function" ? value.bind(target) : value;
      }

      if (prop in target) {
        const value = target[prop];
        return typeof value === "function" ? value.bind(target) : value;
      }

      const raw = target.get(prop);
      return SanitizeHelper.safeText(raw);
    },

    ownKeys(target) {
      return Array.from(target.keys());
    },

    getOwnPropertyDescriptor(target, prop) {
      if (typeof prop === "string" && target.has(prop)) {
        return {
          enumerable: true,
          configurable: true,
          writable: false,
          value: SanitizeHelper.safeText(target.get(prop)),
        };
      }
      return Object.getOwnPropertyDescriptor(target, prop);
    },
  });
};

export default function useQueryParams() {
  let search;
  try {
    const location = useLocation();
    search = location.search;
  } catch {
    search = window.location.search;
  }

  const [proxy, setProxy] = useState(getProxy(search));

  useEffect(() => {
    setProxy(getProxy(search));
  }, [search]);

  return proxy;
}
